// extracted by mini-css-extract-plugin
export var center = "projects-module--center--KZrfT";
export var description = "projects-module--description--j1g30";
export var project = "projects-module--project--oTxFo";